import {
  FeatureFlagModel,
  IFeatureFlagModel,
} from '@common/models/FeatureFlagModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class FeatureFlagService {
  private static baseUrl: string = '/api/featureFlag';

  static tags = {
    upsertFeatureFlag: 'upsertFeatureFlag',
    deleteFeatureFlag: 'deleteFeatureFlag',
  };

  static upsertFeatureFlag = (
    data: IFeatureFlagModel,
    options?: ServiceMethodOptions,
  ): Promise<FeatureFlagModel> => {
    return trackPromise(
      new Promise<IFeatureFlagModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IFeatureFlagModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Feature Flag updated.', options);
            resolve(new FeatureFlagModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Feature Flag.', options);
            reject(err);
          });
      }),
      this.tags.upsertFeatureFlag,
    );
  };

  static deleteFeatureFlag = (
    featureFlagId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${featureFlagId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Feature Flag has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Feature Flag.', options);
            reject(err);
          });
      }),
      this.tags.deleteFeatureFlag,
    );
  };
}
